<template>
  <img :src="file.url" :alt="file.name" loading="lazy" @load="loaded = true">
</template>

<script>
export default {
  name: 'project',
  props: ['url', 'landscape'],
  data() {
    return {
      loaded: false,
    }
  },
  computed: {
    style () {
      return {
        'background-image': this.loaded ? `url(${this.file.url})` : '',
        'background-position': this.backgroundPosition
      }
    },
    file () {
      return this.$store.getters.getFileByURL(this.url)
    },
    backgroundPosition () {
      return this.file.ratio < 1 && this.landscape ? 'left center' : 'center'
    }
  },
}
</script>

<style lang="scss">
@import '../assets/styles/base';

.file {
  height: 100%;
  width: 100%;
  background-size: contain;
  background-position: center;
  background-repeat: no-repeat;
  position: relative;
  object-fit: contain;

  img {
    display: block;
    width: 100%;
    height: auto;
  }
}
</style>



// WEBPACK FOOTER //
// client/components/File.vue